import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ReactQuill from 'react-quill';
import 'src/styles/vendor/react-quill.snow.css';
import {Box} from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import uuidv4 from 'src/utils/uuidv4';
interface discussionData{
  id:string;
  title:string;
  description:string;
  date:string;
  members:string[];
}

interface NewDiscussionDialogProps {
  // eslint-disable-next-line react/boolean-prop-naming
  open: boolean;
  onClose: () => void;
  onStartDiscussion: (
    vals: discussionData[]
  ) => void;
}

const NewDiscussionDialog: React.FC<NewDiscussionDialogProps> = ({
  open,
  onClose,
  onStartDiscussion
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [selectedValue, setSelectedValue] = useState('all');
  const [members, setMembers] = useState<string[]>([]);
  const allMembers = [
    { id: '1', name: 'Alex Johnson' },
    { id: '2', name: 'Morgan Casey' },
    { id: '3', name: 'Jamie Alex' },
    { id: '4', name: 'Sam Chris' },
    { id: '5', name: 'Taylor Morgan' },
    { id: '6', name: 'Jordan Lee' },
    { id: '7', name: 'Casey Harper' },
    { id: '8', name: 'Alexis Bailey' },
    { id: '9', name: 'Pat Jordan' },
    { id: '10', name: 'Drew Casey' }
  ];

  const generateUniqueId = () => {
    const values = uuidv4();
    // Implement a unique ID generation logic here
    return values;
  };
  //   onStartDiscussion(title, description);
  //   onClose();
  // };
  // React.useEffect(() => {
  //   // Create a style element
  //   const style = document.createElement('style');
  //   style.type = 'text/css';
  //   style.innerHTML = `
  //   .ql-editor{
  //       min-height:153px !important
  //   }
  //   .css-19y1325-MuiPaper-root-MuiDialog-paper{
  //       border-radius:17px !important
  //   }
  //   `;
  //   document.head.appendChild(style);

  //   return () => {
  //     // Cleanup the style element from the head
  //     document.head.removeChild(style);
  //   };
  // }, []);
  useEffect(() => {
    // Create a style element
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
      .ql-editor{
          min-height:17vh !important
      }
    `;
    document.head.appendChild(style);

    return () => {
      // Cleanup the style element from the head
      document.head.removeChild(style);
    };
  }, []);
  const currentDate = new Date();
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const valuedate =
    currentDate.getDate() +
    ' ' +
    monthNames[currentDate.getMonth()] +
    ',' +
    currentDate.getFullYear() +
    ' '
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const handleSelectChange = (event: SelectChangeEvent<typeof members>) => {
    const value = event.target.value;
    // For TypeScript, ensure proper casting if necessary
    setMembers(typeof value === 'string' ? value.split(',') : value);
  };

  const handleStart = () => {
    const allMemberIds = allMembers.map(member => member.id);
    const fileToUpload: discussionData[] = [];
      fileToUpload.push({
        id: generateUniqueId(),
        title: title,
        description: description,
        date: valuedate, // Simplified date handling
        members: selectedValue === 'all' ? allMemberIds : members, // Adjust based on selection
      });
          console.log('entered2',fileToUpload)
          onStartDiscussion(fileToUpload);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{padding: '12px 24px'}}>
        <h3 style={{color: 'black'}}>Start a new discussion</h3>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{position: 'absolute', right: 8, top: 8}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          id="title"
          label="Title"
          type="text"
          fullWidth
          variant="outlined"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <div style={{margin: '0.5vh, 0'}}>
          Members:
          <RadioGroup
            style={{display: 'flex', flexDirection: 'row'}}
            aria-label="members"
            name="members"
            value={selectedValue}
            onChange={handleRadioChange}
            row>
            <FormControlLabel
              value="all"
              control={<Radio />}
              label="All members"
            />
            <FormControlLabel
              value="specific"
              control={<Radio />}
              label="Specific members"
            />
          </RadioGroup>
        </div>
        <div>
          {selectedValue === 'all' && (
            <TextField
              fullWidth
              label={
                <Box display="flex" alignItems="center">
                  <InfoOutlinedIcon color="action" sx={{fontSize: '0.8rem'}} />
                  <h6>all members in the course are added</h6>
                </Box>
              }
              variant="standard"
              margin="dense"
              disabled
            />
          )}
          {selectedValue === 'specific' && (
          <FormControl fullWidth margin="normal">
            <InputLabel id="member-select-label">Select Members</InputLabel>
            <Select
              labelId="member-select-label"
              multiple
              value={members}
              onChange={handleSelectChange}
              renderValue={(selected) => selected.join(', ')}
            >
              {allMembers.map(member => (
                <MenuItem key={member.id} value={member.id}>
                  {member.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
          {/* <TextField
          margin="dense"
          id="title"
          label={
            <Box display="flex" alignItems="center">
              <InfoOutlinedIcon color="action" />
              <Typography variant="subtitle1" component="span" sx={{ marginLeft: 1 }}>
                all members in the course are added
              </Typography>
            </Box>
          }
          type="button"
          fullWidth
          variant="standard"
          value={handleselect}
        /> */}
        </div>
        <div style={{marginTop: '4px'}}>
          Description:
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleStart} color="primary">
          Start
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewDiscussionDialog;
